import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import BackModal from '../../BasicElements/BackModal';
import ConfirmModal from '../../BasicElements/ConfirmModal';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const ExpensesCancel = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [username] = useState(cookies.USERNAME);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [editData, setEditData] = useState([]);
	const [inputError, setInputError] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				EXPENSES_MST_ID: props.editData.EXPENSES_MST_ID ?? "",
				USER_MST_GUID: props.editData.USER_MST_GUID ?? "",
				USERNAME: props.editData.USERNAME ?? "",
				TOTAL_CLAIM: props.editData.TOTAL_CLAIM ?? "",
			});
		}
	}, [props.editData]);

	function SaveCancelExpenses() {
		let functionName = "";
		try {
			functionName = SaveCancelExpenses.name;
			props.onLoading(true, "Cancelling this expenses claim, please wait...");
			const data = {
				EXPENSES_MST_ID: editData.EXPENSES_MST_ID,
				USER_MST_GUID: editData.USER_MST_GUID,
				USERNAME: editData.USERNAME,
				TOTAL_CLAIM: editData.TOTAL_CLAIM,
				REASON: editData.REASON,
				UPDATE_NAME: username,
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};
			http
				.post("api/expensesHistory/CancelExpenses", data, { timeout: 5000 })
				.then(() => {
					toast.success("Expenses claim is successfully cancelled.");
					props.onReload();
					hideModal();
				})
				.catch((err) => {
					toast.error("Failed to cancel expenses claim. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to cancel expenses claim. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

	const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setEditData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
		setHasChanges(true);
	}

	//#region Event Handler
	const hideModal = () => {
		setEditData([]);
		setInputError([]);
		setHasChanges(false);
		props.onHide();
	};

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		setEditData([]);
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		if (!editData.REASON || editData.REASON.trim() === "") {
			setInputError((prevState) => ({
				...prevState,
				REASON: "Cancel reason could not be empty.",
			}));
			return;
		}

		if (Object.values(inputError).filter(v => v !== "").length === 0) {
			setShowConfirmModal(true);
		}
	};

	const handleConfirmModal = () => {
		SaveCancelExpenses();
		setShowConfirmModal(false);
		hideModal();
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide back modal on cancel
	};
	//#endregion

	return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
						<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Cancel Expenses</Modal.Title>
					</div>  
				</Modal.Header>
				<Modal.Body>
					<Comp.Input
						id="REASON"
						label="Reason*"
						name="Cancel reason"
						type="text"
						className="form-control"
						errorMessage={inputError.REASON}
						value={editData.REASON}
						onChange={inputRequiredHandler}
					/>
				</Modal.Body>
				<Modal.Footer>
					<div className="onright-container">
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={handleBack}
						>
							<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
																				
						<Comp.Button id="btnSave" onClick={handleConfirm}>
							<FontAwesomeIcon icon={faCheck} />&nbsp; Confirm
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Confirmation Modal */}
			<BackModal
				show={showBackModal}
				onHide={handleConfirmBackCancel}
				onConfirm={handleConfirmBack}
				prop="Confirm Navigation"
			>
				Are you sure you want to go back? Your changes may be lost.
			</BackModal>

			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to cancel"
			>
				Are you sure you want to cancel this expenses claim?
			</ConfirmModal>

			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
			<Comp.AlertPopup />
		</>
	);
};

export default ExpensesCancel;